// plugins/posthog.js
import posthog from 'posthog-js'
import { BASE_URL } from '@/assets/js/config';

export default {
  install(Vue) {
    if (BASE_URL && BASE_URL === 'https://my.fuga.cloud') {
      posthog.init(
        'phc_F0HzU6feKBdTGv53FeOUOPrdI9ZCRciyahkaF0B9s7x',
        {
          api_host: 'https://eu.i.posthog.com',
          capture_pageview: false,
        }
      )

      Vue.prototype.$posthog = posthog
    }
  }
}